import {useMutation} from "@apollo/client";
import toast from "react-hot-toast";
import {Link} from "react-router";

import {GQL_USER_CONTEXT} from "@/lib/queries/accounts.ts";
import {GQL_UPDATE_SUBSCRIPTION, UpdateSubscriptionResponse} from "@/lib/queries/billing.ts";
import {PlanLimit} from "@/lib/types/accounts.ts";
import {BillingPeriod, Plan} from "@/lib/types/billing.ts";
import {CheckTypeDisplay, MonitoringServiceType} from "@/lib/types/checks.ts";
import {InstantPopUp} from "@/pages/billing/v1/instantCheckout/InstantPopUp.tsx";
import {LegacyPlanBox} from "@/pages/billing/v1/instantCheckout/LegacyPlanBox.tsx";

interface PopupUpgradePlanProps {
  show: boolean;
  onComplete: () => void;
  service: MonitoringServiceType;
  price: number;
  period: BillingPeriod;
  plan: string;
  planLimit: PlanLimit;
}

export const PopupUpgradePlan = ({
  show,
  service,
  onComplete,
  plan,
  price,
  period,
  planLimit,
}: PopupUpgradePlanProps) => {
  const [updateSubscription, {loading}] = useMutation<UpdateSubscriptionResponse>(GQL_UPDATE_SUBSCRIPTION, {
    refetchQueries: [GQL_USER_CONTEXT],
  });
  const usedAny = planLimit.used > 0;
  const callout = usedAny
    ? `You have reached the limit of ${planLimit.allowed} ${CheckTypeDisplay[service]} Checks on your current plan`
    : `${CheckTypeDisplay[service]} Checks are not available on your current plan`;
  return (
    <InstantPopUp
      show={show}
      loading={loading}
      onConfirm={async () => {
        const r = await updateSubscription({variables: {plan, billingPeriod: period}});
        if (r.data?.updateSubscription.success) {
          toast.success("Plan updated successfully.");
        }

        onComplete();
      }}
      title={`Upgrade to add ${CheckTypeDisplay[service]} Checks`}
      alertCallout={callout}
      alertChildren={
        <span>
          <br />
          Upgrade now to add {CheckTypeDisplay[service]} checks to your account.&nbsp;
          <Link to="/billing?action=subscribe">View all plans</Link>
        </span>
      }
      onCancel={onComplete}
      btnTitle="Upgrade Now"
    >
      <LegacyPlanBox plan={plan as Plan} price={price} period={period} />
    </InstantPopUp>
  );
};
